module.exports = __webpack_public_path__ + "static/media/icon_language.ae1ef10b.svg";